import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Footer from "../../../Include/Footer";
import PageHeader from "../../Components/Breadcrumbs/PageHeader";
import moment from "moment";
import { Pagination, Search } from "../../../Table";
import DropDown from "../../../../../Components/DropDown";
import { useDispatch, useSelector } from "react-redux";
import { getUserAdminDraw } from "../../../../../Store/Erp/Planner/Draw/UserAdminDraw";
import SubmitButton from "../../Components/SubmitButton/SubmitButton";

const ViewMultiClearWeldVisual = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location.state;

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    dispatch(getUserAdminDraw());
  }, [dispatch]);

  const drawData = useSelector((state) => state?.getUserAdminDraw?.user?.data);

  const getDrawing = (drawId) => drawData?.find((dr) => dr?._id === drawId);

  const commentsData = useMemo(() => {
    let computed = data?.items || [];

    if (search) {
      computed = computed.filter(
        (item) =>
          item?.grid_item_id?.item_name?.name
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          item?.grid_item_id?.grid_id?.grid_no
            ?.toLowerCase()
            ?.includes(search.toLowerCase())
      );
    }

    setTotalItems(computed.length);

    return computed.slice((currentPage - 1) * limit, currentPage * limit);
  }, [search, limit, currentPage, data]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          {/* BREADCRUMB */}
          <PageHeader
            breadcrumbs={[
              { name: "Dashboard", link: "/user/project-store/dashboard" },
              {
                name: "Weld Visual Clearance List",
                link: "/user/project-store/weld-visual-clearance-management",
              },
              { name: "View Weld Visual Clearance", active: true },
            ]}
          />
          {/* HEADER CARD */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>View Weld Visual Clearance Details</h4>
                      </div>
                    </div>
                    <div className="row">
                      {[
                        {
                          label: "Weld Visual Offer No.",
                          value: data?.report_no,
                        },
                        {
                          label: "Weld Visual Ins. No.",
                          value: data?.report_no_two,
                        },
                        {
                          label: "Inspected By",
                          value: data?.qc_name?.user_name,
                        },
                        {
                          label: "Inspected Date",
                          value: moment(data?.qc_time).format(
                            "YYYY-MM-DD HH:mm"
                          ),
                        },
                      ].map((item, i) => (
                        <div key={i} className="col-12 col-md-6 col-xl-6">
                          <div className="input-block local-forms custom-select-wpr">
                            <label>{item.label}</label>
                            <input
                              value={item.value || "-"}
                              readOnly
                              className="form-control"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Weld Visual Clearance Section List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <Search
                                  onSearch={(value) => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                  }}
                                />
                                <a className="btn">
                                  <img
                                    src="/assets/img/icons/search-normal.svg"
                                    alt="search"
                                  />
                                </a>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                        <DropDown
                          limit={limit}
                          onLimitChange={(val) => setLimit(val)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive mt-2">
                    <table className="table border-0 custom-table comman-table  mb-0">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th>Drawing No</th>
                          <th>Rev</th>
                          <th>Assembly No</th>
                          <th>Item</th>
                          <th>Grid</th>
                          <th>Weld Type</th>
                          <th>Weld Length</th>
                          <th>Status</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {commentsData.map((item, i) => (
                          <tr key={i}>
                            <td>{(currentPage - 1) * limit + i + 1}</td>
                            <td>{getDrawing(item?.drawing_id)?.drawing_no}</td>
                            <td>{getDrawing(item?.drawing_id)?.rev}</td>
                            <td>{getDrawing(item?.drawing_id)?.assembly_no}</td>
                            <td>{item?.grid_item_id?.item_name?.name}</td>
                            <td>{item?.grid_item_id?.grid_id?.grid_no}</td>
                            <td>
                              {item?.joint_type?.map((j) => j.name).join(", ")}
                            </td>
                            <td>{item?.weld_length || "-"}</td>
                            <td className="status-badge">
                              {item?.is_accepted === true ? (
                                <span className="custom-badge status-green">
                                  Accepted
                                </span>
                              ) : item?.is_accepted === false ? (
                                <span className="custom-badge status-pink">
                                  Rejected
                                </span>
                              ) : (
                                <span className="custom-badge status-orange">
                                  Pending
                                </span>
                              )}
                            </td>
                            <td>{item?.qc_remarks || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_0_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {Math.min(limit, totalItems)} from {totalItems}{" "}
                        data
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate"
                      >
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <SubmitButton
            finalReq={data?.items}
            link="/user/project-store/weld-visual-clearance-management"
          />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewMultiClearWeldVisual;
